// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__REHSl","label":"Radio_label__1Q-Jw","checkMark":"Radio_checkMark__1RMOD","disabled":"Radio_disabled__11otH"};